import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import SectionTitle from "../sectionTitle/SectionTitle";
import ContactOne from "./ContactOne";
import ContactAccordion from '../accordion/ContactAccordion';
import Separator from '../separator/Separator';

const Contact = () => {
    return (
        <>
            <SEO title="Contact" />
            <Layout>
                <BreadcrumbOne 
                    title="The Easiest Way To Grow Your Business <br /> With PWU"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Contact"
                />
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Contact Form"
                                        title = "Our Contact Address Here."
                                        description = ""
                                    />
                                </div>
                            </div>
                            <ContactOne />
                        </div>
                    </div>
                    {/* End Contact Area  */}

                    <Separator />
                {/* Start Elements Area  Contact Accordion*/}
                {/* <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <h3 className='text-center'>Frequently Asked Questions About US</h3>
                            </div>
                        </div>
                        <ContactAccordion/>
                    </div>
                </div> */}
                {/* End Elements Area  */}
                </div>
            </Layout>
        </>
    )
}
export default Contact;